import React, { createContext, useContext, useState } from 'react';

export interface TabContextType {
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  changeTab: (tab: string) => void;
}

const TabContext = createContext<TabContextType | undefined>(undefined);

export const useTabContext = () => {
  const context = useContext(TabContext);
  if (context === undefined) {
    throw new Error('useTabContext must be used within a TabContextProvider');
  }
  return context;
};

interface TabContextProviderProps {
  children: React.ReactNode;
}

export const TabContextProvider: React.FC<TabContextProviderProps> = ({ children }) => {
  const [activeTab, setActiveTab] = useState<string>("");

  const changeTab = (newTab: string) => {
    setActiveTab(newTab);
  };

  return (
    <TabContext.Provider value={{ activeTab, setActiveTab, changeTab }}>
      {children}
    </TabContext.Provider>
  );
};
